import { render } from "@/components/pages/dataRecollection/workSupport/WorkSupportPageReq05.html?vue&type=template&id=c49c555a&external"
import script from "@/components/pages/dataRecollection/workSupport/WorkSupportPageReq05.js?vue&type=script&lang=js&external"
export * from "@/components/pages/dataRecollection/workSupport/WorkSupportPageReq05.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__